<template>
  <b-card no-body v-if="this.fleetData && this.fleetData.deviceId">
    <b-card-body>
      <b-container fluid="xl">
        <b-row align-v="center">
          <b-col cols="2">
            <div>
              <router-link :to="{ name: 'asset-detail', params: { type: 'ASSET', entityId: this.fleetData.assetId }}">
                {{ this.fleetData.assetName }}
              </router-link>
            </div>
          </b-col>
          <b-col cols="2">
            <div>
              <router-link :to="{ name: 'driver-detail', params: { type: 'DRIVER', entityId: this.fleetData.driverId }}">
                {{ this.fleetData.driverName }}
              </router-link>
            </div>
          </b-col>
          <b-col cols="1">
            <div v-if="this.fleetData.trip">
              Driving
            </div>
            <div v-else>
              Stationary
            </div>
          </b-col>
          <b-col cols="3">
            <div v-if="this.tripStartAddress">
              {{ this.tripStartAddress }}
            </div>
            <div v-if="this.tripEndAddress">
              {{ this.tripEndAddress }}
            </div>
          </b-col>
          <b-col cols="1" align="center">
            <div v-if="this.fleetData.tripStartTime">
              Trip start
              <div>
                {{ $formatDate(new Date(this.fleetData.tripStartTime)) }}
              </div>
              <div>
                <h3>{{ $formatTime(new Date(this.fleetData.tripStartTime)) }}</h3>
              </div>
            </div>
            <div v-if="this.fleetData.tripEndTime">
              Trip end
              <div>
                {{ $formatDate(new Date(this.fleetData.tripEndTime)) }}
              </div>
              <div>
                <h3>{{ $formatTime(new Date(this.fleetData.tripEndTime)) }}</h3>
              </div>
            </div>
          </b-col>
          <b-col cols="1" align="center">
            Last data
            <div>
              {{ $formatDate(new Date(this.fleetData.time)) }}
            </div>
            <div>
              <h3>{{ $formatTime(new Date(this.fleetData.time)) }}</h3>
            </div>
          </b-col>
          <b-col cols="1" align="right">
            <div v-if="this.fleetData.drivingStyleData">
              <p/>
              <base-button size="sm" type="primary" v-b-toggle="this.fleetData.assetId" class="m-1">Details</base-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-card-body>
    <b-collapse :id="this.fleetData.assetId">
      <b-row cols="12">
        <b-col cols="4">
          <b-card v-if="this.fleetData.drivingStyleData">
            Stats
            <stats-card :statsData="this.fleetData.drivingStyleData"/>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card v-if="this.fleetData.scoreData">
            Score
            <score-card :scoreData="this.fleetData.scoreData"/>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card v-if="this.fleetData.datapoints">
            Events
            <b-card-body >
              <div v-for="(dp, dpIndex) in this.fleetData.datapoints">
                <h3 v-for="(event, eventIndex) in dp.events">{{ $formatTime(new Date(Date.parse(dp.timestamp))) }} : {{ event.eventType }} </h3>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-collapse>
  </b-card>
</template>

<script>
import axios from "axios";
import StatsCard from "./StatsCard";
import ScoreCard from "./ScoreCard";

export default {
  name: "fleet-card",
  props: {
    fleetData: {
      type: Object,
      description: "Fleet data object"
    }
  },
  components: {
    StatsCard,
    ScoreCard
  },
  data: _ => ({
    tripStartAddress: undefined,
    tripEndAddress: undefined
  }),
  created() {
    if (this.fleetData.tripStartLocation) {
      this.$reverseGeocode(this.fleetData.tripStartLocation).then(response => {
        this.tripStartAddress = response.data.results[0].formatted_address
      })
    }
    if (this.fleetData.tripEndLocation) {
      this.$reverseGeocode(this.fleetData.tripEndLocation).then(response => {
        this.tripEndAddress = response.data.results[0].formatted_address
      })
    }
  },
}
</script>
